// extracted by mini-css-extract-plugin
module.exports = {"dayDivider":"speaker_dayDivider__yB2hD","session":"speaker_session__8r7mM","timing":"speaker_timing__4U2ZZ","titleLink":"speaker_titleLink__6UO2F"};